export default {
  name: 'WootTabs',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { hasScroll: false, isRTL: false };
  },
  created() {
    window.addEventListener('resize', this.computeScrollWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.computeScrollWidth);
  },
  mounted() {
    this.isRTL = getComputedStyle(this.$el).direction === 'rtl';
    this.computeScrollWidth();
  },
  methods: {
    computeScrollWidth() {
      const tabElement = this.$el.getElementsByClassName('tabs')[0];
      this.hasScroll = tabElement.scrollWidth > tabElement.clientWidth;
    },
    // `scrollLeft` decreases as content moves leftward in both directions, so the
    // arithmetic is shared; what flips is which edge of the strip each button sits
    // on. In Arabic the first button lands on the right and has to walk backwards.
    onScrollClick(edge) {
      const tabElement = this.$el.getElementsByClassName('tabs')[0];
      const towardsStart = edge === 'start';
      const movesLeft = this.isRTL ? !towardsStart : towardsStart;
      const scrollPosition = tabElement.scrollLeft + (movesLeft ? -100 : 100);
      tabElement.scrollTo({
        top: 0,
        left: scrollPosition,
        behavior: 'smooth',
      });
    },
    createScrollButton(createElement, edge) {
      if (!this.hasScroll) {
        return false;
      }
      // Logical edge only — no `isRTL` here. FluentIcon mirrors both chevrons in RTL
      // (`Icon.vue` + `RTL_MIRRORED_ICONS`), so swapping the glyph here as well flipped
      // it twice and pointed both buttons the wrong way in Arabic.
      const pointsLeft = edge === 'start';
      return createElement(
        'button',
        {
          // Kept out of the a11y tree on purpose: the tabs themselves are reachable
          // with Tab and the arrow keys, so these are a duplicate pointer
          // affordance, not a control anyone needs announced.
          attrs: {
            type: 'button',
            tabindex: '-1',
            'aria-hidden': 'true',
          },
          class: 'tabs--scroll-button button clear secondary button--only-icon',
          on: { click: () => this.onScrollClick(edge) },
        },
        [
          createElement('fluent-icon', {
            props: {
              icon: pointsLeft ? 'chevron-left' : 'chevron-right',
              size: 16,
            },
          }),
        ]
      );
    },
  },
  render(createElement) {
    const Tabs = this.$slots.default
      .filter(
        node =>
          node.componentOptions &&
          node.componentOptions.tag === 'woot-tabs-item'
      )
      .map((node, index) => {
        const data = node.componentOptions.propsData;
        data.index = index;
        return node;
      });
    const startButton = this.createScrollButton(createElement, 'start');
    const endButton = this.createScrollButton(createElement, 'end');
    return (
      <div
        class={{
          'tabs--container--with-border': this.border,
          'tabs--container': true,
        }}
      >
        {startButton}
        <ul
          role="tablist"
          class={{ tabs: true, 'tabs--with-scroll': this.hasScroll }}
        >
          {Tabs}
        </ul>
        {endButton}
      </div>
    );
  },
};
